import { render, staticRenderFns } from "./LoginRelation.vue?vue&type=template&id=5d9c8964&scoped=true"
import script from "./LoginRelation.vue?vue&type=script&lang=js"
export * from "./LoginRelation.vue?vue&type=script&lang=js"
import style0 from "./LoginRelation.vue?vue&type=style&index=0&id=5d9c8964&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9c8964",
  null
  
)

export default component.exports